<template>
    <div class="uik-tooltip">
        <slot></slot>
        <div class="uik-tooltip__tooltip-container">
            <div
                class="uik-tooltip__tooltip"
                :class="{'uik-tooltip__tooltip--no-pointer-events': noPointerEvents}"
            >
                <p><Uikon v-if="icon" :icon="icon"/><span v-html="text"/></p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "UikTooltip",
    props: {
        icon: { type: String, default: "" },
        text: { type: String, default: "", required: true }, // Use "<br/>" to break text into a new line
        noPointerEvents: { type: Boolean, default: false } // Prevent inheriting parent's pointer events
    }
}
</script>

<style lang="scss">
.uik-tooltip {
    width: auto;
    margin: 0;
    padding: 0;
    display: inline-flex;
    flex-flow: column-reverse nowrap;
    &:hover .uik-tooltip__tooltip-container .uik-tooltip__tooltip {
        display: inline-flex;
    }
    .uik-tooltip__tooltip-container {
        position: static;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        .uik-tooltip__tooltip {
            z-index: 2;
            width: auto;
            margin: 0 auto;
            display: none;
            justify-content: center;
            align-items: center;
            position: absolute;
            padding: 7px 10px;
            background: white;
            border-radius: 4px;
            transform: translateY(-10px);
            animation: uik-tooltip-appear 0.2s both;
            border: $borderDefault;
            box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.04);
            .uikon {
                color: $textSecondary;
                font-size: 12px;
            }
            p {
                text-align: left;
                text-align-last: left;
                z-index: 3;
                font-size: 13px;
                color: $textBase;
                width: 100%;
                line-height: 18px;
                white-space: nowrap;
            }
            &:after {
                content: "";
                width: 10px;
                height: 10px;
                background: inherit;
                bottom: -6px;
                transform: rotate(45deg);
                position: absolute;
                z-index: inherit;
                border-bottom: inherit;
                border-right: inherit;
                box-shadow: inherit;
            }
        }
        .uik-tooltip__tooltip--no-pointer-events {
            pointer-events: none;
        }
    }
}
@keyframes uik-tooltip-appear {
    from {
        transform: translateY(0);
        opacity: 0;
    }
    to {
        transform: translateY(-10px);
        opacity: 1;
    }
}
</style>
